import React from 'react';

import * as api from "../../util/apiPublic";
import * as util from "../../util";

import Login from "../Login";

import "./index.scss";

export default class Winners extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: undefined,
      rawAttendeesList: [],
      repeatedAttendeesList: [],
      pickedWinnerIds: [],
      newWinner: undefined,
      isHideWinners: false
    };

    window._animateWinnerList = this._animateWinnerList;
  }

  _animateWinnerList(itemSelector, cb, doAnimation = true) {
    const allItems = $(".winners-list-item");

    if (!allItems.length) return;

    const groupContainer = $(".winners-list-grouping");
    const targetItem = typeof itemSelector === "number" ? $(`.winners-list-item:nth(${itemSelector})`) : $(itemSelector);
    const itemWidth = $(".winners-list-item").outerWidth(true);
    const winWidth = document.body.clientWidth;
    const firstItemLeft = $(".winners-list-item:nth(0)").offset().left;
    const viewportLeft = $(".winners-list-viewport").offset().left;

    const leftPos = (
      targetItem.offset().left
      - firstItemLeft
      - Math.floor(winWidth / 2)
      + viewportLeft
      + (itemWidth / 2)
    );

    groupContainer.css({
      "transform": `translateX(${-leftPos}px)`,
      "transition-property": doAnimation ? "all" : "none"
    });

    this._animateTimer = cb && setTimeout(cb, 5000);
  }

  _hideWinners() {
    this.setState({
      isHideWinners: !this.state.isHideWinners
    });
  }

  componentDidMount() {
    if (!util.isAuthenticated()) return;

    const drawingId = this.props.match.params.id;

    api.getDrawing(drawingId)
      .then(res => {
        const { data } = res;

        this.setState({ data });
      });

    const repeatArr = (arr, n, processor) => {
      // Repeat the given array n times.
      const repeatedArr = [].concat(...Array(n).fill(arr));

      // If a processor function was provided, process the repeated array.
      const repeatedProcessedArr = processor && repeatedArr.map((item, index) => processor(item, index));

      return repeatedProcessedArr || repeatedArr;
    }

    // Refresh attendees list every second for updated entries count/checking new winners.
    const fn = interval => setTimeout(() => {
      api.getLimitedAttendeeListWithAllWinners({ drawingId })
        .then(res => {
          // Assign a unique key to each list item.
          const assignKeyToAttendeeFn = (item, index) => {
            const { key, profile_id } = item;

            return {
              ...item,
              key: `${key || profile_id}$${index}` // Format: ########-####-####-####-############$#
            };
          };

          /**
          * The newest winner is updated if all conditions below are met.
          *
          * 1. The "won" flag IS set in data fetched from back-end.
          * 2. The profile ID of the winner IS NOT present in the dynamic picked winners list.
          * 3. If a profile ID fragment is passed to the page, the profile ID matches the one which meets the criteria above.
          */
          const newWinnerSearch = (
            res.data.find(attendee => {
              const profileIdFragment = window.location.hash.substring(1);
              const profileIdFragmentMatches = !profileIdFragment || (profileIdFragment === attendee.profile_id);

              if (!attendee.won) return;
              if (this.state.pickedWinnerIds.includes(attendee.profile_id)) return;
              if (!profileIdFragmentMatches) return;

              return attendee;
            })
          );

          const newWinner = newWinnerSearch || this.state.newWinner;

          // Copy the data from fetch but change the won flags to false so the app will only have a single won flag.
          const rawAttendeesList = res.data.map(attendee => {
            return {
              ...attendee,
              won: false
            }
          });

          // Update the list of winners picked only if a new winner has been identified.
          const pickedWinnerIds = (
            newWinner !== this.state.newWinner
              ? [...this.state.pickedWinnerIds, newWinner.profile_id]
              : [...this.state.pickedWinnerIds]
          );

          // Calculate the number of times the list should be repeated.
          const repeatN = (
            rawAttendeesList.length < 50
              ? Math.ceil(50 / rawAttendeesList.length)
              : 1
          );

          /**
          * Create the repeated list - the raw list repeated based on repeatN and number of winners picked.
          * The list is momentarily reversed so that findIndex() can be used.
          */
          let repeatedAttendeesList = repeatArr(
            [...rawAttendeesList],
            repeatN * pickedWinnerIds.length,
            assignKeyToAttendeeFn
          ).reverse();

          // The index of the last winner is where the new winner's profile ID matches a profile ID in the repeated list.
          const lastWinnerIndex = (
            newWinner
              ? repeatedAttendeesList.findIndex(attendee => attendee.profile_id === newWinner.profile_id)
              : -1
          );

          // Set the "won" flag back to true to be picked up by the animation and reverse the list back.
          if (lastWinnerIndex >= 0) {
            repeatedAttendeesList[lastWinnerIndex].won = true;
            repeatedAttendeesList.reverse();
          }

          this.setState({
            rawAttendeesList,
            repeatedAttendeesList,
            pickedWinnerIds,
            newWinner
          });

          this.countdownTimer = fn(3000);
        });
    }, interval);

    this.countdownTimer = fn(0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { pickedWinnerIds } = this.state;

    if (pickedWinnerIds.length === prevState.pickedWinnerIds.length) return;

    const winnersShowcaseContainer = $(".winners-showcase");

    this._animateTimer && clearTimeout(this._animateTimer);

    winnersShowcaseContainer.css({
      "opacity": "0",
      "transition-property": "none"
    });

    const pickedWinnerEl = $(".winners-list-item[data-won='true']:last")[0];

    this._animateWinnerList(pickedWinnerEl, () => {
      winnersShowcaseContainer.css({
        "opacity": "1",
        "transition-property": "all"
      });
    });
  }

  renderInitials(name) {
    return (
      <div className="winners-list-item-initials d-flex align-items-center justify-content-center">
        {util.avatarInitials(name)}
      </div>
    );
  }

  renderAvatar(name, avatar) {
    return (
      <img
        className="winners-list-item-avatar"
        src={avatar}
        alt={`${name}'s Avatar`}
      />
    );
  }

  _renderWinners() {
    const { data, rawAttendeesList, pickedWinnerIds, isHideWinners } = this.state;
    const { show_profile_photo } = data || {};
    const pickedWinnersNum = pickedWinnerIds.length;

    if (pickedWinnersNum < 2) return;

    return (
      <div className={`drawing-winners-list${isHideWinners ? " hide-winners-list" : ""}`}>
        <div className="drawing-winners-list-title">
          Winners
        </div>

        <div className="drawing-winners-list-items">
          {
            rawAttendeesList.filter(attendee => attendee.won).map(attendee => {
              const { avatar, name, company } = attendee;

              return (
                <div className="drawing-winners-list-item">
                  {show_profile_photo && avatar ? this.renderAvatar(name, avatar) : this.renderInitials(name)}

                  <div className="drawing-winners-list-item-info">
                    <div className="winner-name">{name}</div>

                    <div className="winner-company">{company}</div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }

  render() {
    if (!util.isAuthenticated()) return <Login />;

    const {
      data,
      rawAttendeesList,
      repeatedAttendeesList,
      pickedWinnerIds,
      newWinner
    } = this.state;
    console.log({
      data,
      rawAttendeesList,
      repeatedAttendeesList,
      pickedWinnerIds,
      newWinner
    });

    const { show_profile_photo } = data || {};
    const attendeesNum = rawAttendeesList.length;
    const pickedWinnersNum = pickedWinnerIds.length;

    const childElements = repeatedAttendeesList.map(attendee => {
      const { key, profile_id, avatar, name, won } = attendee;

      return (
        <div
          className="winners-list-item"
          id={profile_id}
          key={key || profile_id}
          data-won={won}
        >
          {show_profile_photo && avatar ? this.renderAvatar(name, avatar) : this.renderInitials(name)}
        </div>
      );
    });

    return (
      <div
        className="drawing-winners d-flex align-items-center justify-content-center"
        onDoubleClick={() => this._hideWinners()}
      >
        {/* {this._renderWinners()} */}

        <div className="abstract-left"></div>

        <div className="abstract-right"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="entries-count-text">
                Drawing Announcement
              </div>
            </div>
          </div>

          {
            // Don't need to show this yet if we haven't picked any winners.
            pickedWinnersNum > 0
            && <div className="row justify-content-center">
              <div className="col-12">
                <div className="entries-winner-text">
                  <span className="entries-winner-text-white">The winner is</span>
                </div>
              </div>
            </div>
          }

          {
            // Don't need to show this yet if we haven't picked any winners.
            pickedWinnersNum > 0
            && <div className="row">
              <div className="col-12">
                <div className="winners-list-viewport">
                  <div className="winners-list-grouping">
                    {childElements}
                  </div>

                  <div id="viewport-overlay-left" className="viewport-overlay"></div>

                  <div id="viewport-overlay-right" className="viewport-overlay"></div>
                </div>
              </div>
            </div>
          }

          {
            // Don't need to show this yet if we haven't got a new winner.
            newWinner
            && <div className="row">
              <div className="col-12">
                <div className="winners-showcase">
                  <div className="winners-showcase-name">{newWinner.name}</div>
                  <div className="winners-showcase-company">{newWinner.company || "Congratulations!"}</div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}
